import { render, staticRenderFns } from "./PeriodList.vue?vue&type=template&id=7ad60c66"
import script from "../../controllers/academic_period/period-list.js?vue&type=script&lang=js&external"
export * from "../../controllers/academic_period/period-list.js?vue&type=script&lang=js&external"
import style0 from "./PeriodList.vue?vue&type=style&index=0&id=7ad60c66&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports